/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddItemOrderReq } from '../models/add-item-order-req';
import { AddNewStatusReq } from '../models/add-new-status-req';
import { CancelOrderReq } from '../models/cancel-order-req';
import { CategoryRankingReq } from '../models/category-ranking-req';
import { CategoryRankingResp } from '../models/category-ranking-resp';
import { DeleteItemOrderReq } from '../models/delete-item-order-req';
import { GetActionsDto } from '../models/get-actions-dto';
import { GetAllOdersReq } from '../models/get-all-oders-req';
import { GetAllOdersResp } from '../models/get-all-oders-resp';
import { ImportOrderReq } from '../models/import-order-req';
import { OrderHistorytResp } from '../models/order-historyt-resp';
import { PutOrderReq } from '../models/put-order-req';
import { PutOrderResp } from '../models/put-order-resp';
import { RevertLastStatusReq } from '../models/revert-last-status-req';
import { GetOrderByStatusReq } from '../models/get-order-by-status-req';
import { GetOrderByStatusrResp } from '../models/get-order-by-statusr-resp';
import { GetOrderReq } from '../models/get-order-req';
import { GetOrderResp } from '../models/get-order-resp';

@Injectable({
  providedIn: 'root',
})
export class OrdersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation putOrder
   */
  static readonly PutOrderPath = '/order';

  /**
   * Update order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putOrder$Response(params: {
    body: PutOrderReq
  }): Observable<StrictHttpResponse<PutOrderResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.PutOrderPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PutOrderResp>;
      })
    );
  }

  /**
   * Update order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putOrder(params: {
    body: PutOrderReq
  }): Observable<PutOrderResp> {

    return this.putOrder$Response(params).pipe(
      map((r: StrictHttpResponse<PutOrderResp>) => r.body as PutOrderResp)
    );
  }

  /**
   * Path part for operation getAllOders
   */
  static readonly GetAllOdersPath = '/order';

  /**
   * Get all orders
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOders()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllOders$Response(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: GetAllOdersReq
  }): Observable<StrictHttpResponse<GetAllOdersResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.GetAllOdersPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetAllOdersResp>;
      })
    );
  }

  /**
   * Get all orders
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllOders$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllOders(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: GetAllOdersReq
  }): Observable<GetAllOdersResp> {

    return this.getAllOders$Response(params).pipe(
      map((r: StrictHttpResponse<GetAllOdersResp>) => r.body as GetAllOdersResp)
    );
  }

  /**
   * Path part for operation categoryRanking
   */
  static readonly CategoryRankingPath = '/order/category-ranking';

  /**
   * Category Ranking
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryRanking()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryRanking$Response(params: {
    body: CategoryRankingReq
  }): Observable<StrictHttpResponse<CategoryRankingResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.CategoryRankingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoryRankingResp>;
      })
    );
  }

  /**
   * Category Ranking
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categoryRanking$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryRanking(params: {
    body: CategoryRankingReq
  }): Observable<CategoryRankingResp> {

    return this.categoryRanking$Response(params).pipe(
      map((r: StrictHttpResponse<CategoryRankingResp>) => r.body as CategoryRankingResp)
    );
  }

  /**
   * Path part for operation getOrder
   */
  static readonly GetOrderPath = '/order/get';

  /**
   * A order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getOrder$Response(params: {
    body: GetOrderReq
  }): Observable<StrictHttpResponse<GetOrderResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.GetOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetOrderResp>;
      })
    );
  }

  /**
   * A order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getOrder(params: {
    body: GetOrderReq
  }): Observable<GetOrderResp> {

    return this.getOrder$Response(params).pipe(
      map((r: StrictHttpResponse<GetOrderResp>) => r.body as GetOrderResp)
    );
  }

  /**
   * Path part for operation orderHistory
   */
  static readonly OrderHistoryPath = '/order/history/{uuid}';

  /**
   * Get all the history of an order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderHistory$Response(params: {

    /**
     * order uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<OrderHistorytResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.OrderHistoryPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderHistorytResp>;
      })
    );
  }

  /**
   * Get all the history of an order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `orderHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderHistory(params: {

    /**
     * order uuid
     */
    uuid: string;
  }): Observable<OrderHistorytResp> {

    return this.orderHistory$Response(params).pipe(
      map((r: StrictHttpResponse<OrderHistorytResp>) => r.body as OrderHistorytResp)
    );
  }

  /**
   * Path part for operation getOrderByStatus
   */
  static readonly GetOrderByStatusPath = '/order/by-status';

  /**
   * Orders by status
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrderByStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getOrderByStatus$Response(params: {
    body: GetOrderByStatusReq
  }): Observable<StrictHttpResponse<GetOrderByStatusrResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.GetOrderByStatusPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetOrderByStatusrResp>;
      })
    );
  }

  /**
   * Orders by status
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOrderByStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getOrderByStatus(params: {
    body: GetOrderByStatusReq
  }): Observable<GetOrderByStatusrResp> {

    return this.getOrderByStatus$Response(params).pipe(
      map((r: StrictHttpResponse<GetOrderByStatusrResp>) => r.body as GetOrderByStatusrResp)
    );
  }

  /**
   * Path part for operation revertLastStatus
   */
  static readonly RevertLastStatusPath = '/order/revert-last-status';

  /**
   * Revert to last order status
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revertLastStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revertLastStatus$Response(params: {
    body: RevertLastStatusReq
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.RevertLastStatusPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Revert to last order status
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `revertLastStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revertLastStatus(params: {
    body: RevertLastStatusReq
  }): Observable<void> {

    return this.revertLastStatus$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation addNewStatus
   */
  static readonly AddNewStatusPath = '/order/add-new-status';

  /**
   * add new order status
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addNewStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNewStatus$Response(params: {
    body: AddNewStatusReq
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.AddNewStatusPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * add new order status
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addNewStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNewStatus(params: {
    body: AddNewStatusReq
  }): Observable<void> {

    return this.addNewStatus$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation cancelOrder
   */
  static readonly CancelOrderPath = '/order/cancel';

  /**
   * Cancel order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cancelOrder$Response(params: {
    body: CancelOrderReq
  }): Observable<StrictHttpResponse<GetActionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.CancelOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetActionsDto>;
      })
    );
  }

  /**
   * Cancel order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cancelOrder(params: {
    body: CancelOrderReq
  }): Observable<GetActionsDto> {

    return this.cancelOrder$Response(params).pipe(
      map((r: StrictHttpResponse<GetActionsDto>) => r.body as GetActionsDto)
    );
  }

  /**
   * Path part for operation deleteItemOrder
   */
  static readonly DeleteItemOrderPath = '/order/delete-item';

  /**
   * Delete element from order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteItemOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteItemOrder$Response(params: {
    body: DeleteItemOrderReq
  }): Observable<StrictHttpResponse<GetActionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.DeleteItemOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetActionsDto>;
      })
    );
  }

  /**
   * Delete element from order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteItemOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteItemOrder(params: {
    body: DeleteItemOrderReq
  }): Observable<GetActionsDto> {

    return this.deleteItemOrder$Response(params).pipe(
      map((r: StrictHttpResponse<GetActionsDto>) => r.body as GetActionsDto)
    );
  }

  /**
   * Path part for operation addItemOrder
   */
  static readonly AddItemOrderPath = '/order/add-item';

  /**
   * Add element from order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addItemOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addItemOrder$Response(params: {
    body: AddItemOrderReq
  }): Observable<StrictHttpResponse<GetActionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.AddItemOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetActionsDto>;
      })
    );
  }

  /**
   * Add element from order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addItemOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addItemOrder(params: {
    body: AddItemOrderReq
  }): Observable<GetActionsDto> {

    return this.addItemOrder$Response(params).pipe(
      map((r: StrictHttpResponse<GetActionsDto>) => r.body as GetActionsDto)
    );
  }

  /**
   * Path part for operation importOrder
   */
  static readonly ImportOrderPath = '/order/import';

  /**
   * Import order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importOrder$Response(params: {
    body: ImportOrderReq
  }): Observable<StrictHttpResponse<GetActionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, OrdersService.ImportOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetActionsDto>;
      })
    );
  }

  /**
   * Import order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `importOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importOrder(params: {
    body: ImportOrderReq
  }): Observable<GetActionsDto> {

    return this.importOrder$Response(params).pipe(
      map((r: StrictHttpResponse<GetActionsDto>) => r.body as GetActionsDto)
    );
  }

}
